import React from 'react'
import { Radar } from 'react-chartjs-2'

/**
 * Composant pour le graphique mitre_attack (Radar)
 */
const MitreAttackChart = ({ data, options }) => {
  if (!data || !options || !data.labels || !data.datasets) {
    return null
  }

  return (
    <Radar
      id="chart_mitre_attack"
      options={options}
      data={data}
    />
  )
}

export default MitreAttackChart
